import axios from "axios";
import sha1 from "sha1";

export const READ_API_BASE_URL = '//readapi.bluebirdabc.com';
const LESSON_PLAYER_API_BASE_URL= READ_API_BASE_URL+"/lesson/player/";

function generateRandomString(length) {
    let result = '';
    const charactersLength = length;
    for (let i = 0; i < length; i++) {
        const randomValue = Math.floor((Date.now() * Math.random()) % charactersLength);
        result += String.fromCharCode(randomValue + 65);
    }
    return result;
}

function makeWebApiAuthObject(queries) {
    /*
     * 以下草稿不走登录验证: 国家开放大学
     */
    if ([179, 180, 181, 190, 191].includes(queries.lessonId)) {
        return {
            token: '',
            timestamp: '', //当前毫秒值
            rand: '', //随机字符串
            sign: '',      //签名串
            ...queries
        };
    }

    let user_id = localStorage.getItem('lesson.player.user_id');
    let pid = localStorage.getItem('lesson.player.pid');
    let token = localStorage.getItem('lesson.player.token');

    //清大智汇 夺分派智能阅读 暂时不做登录验证
    if(pid === 'w7398uoaiIAF98wu') {
        return {
            token: '',
            timestamp: '', //当前毫秒值
            rand: '', //随机字符串
            sign: '',      //签名串
            ...queries
        };
    }

    //
    if (!(user_id && pid && token)) {
        return false;
    }

    let num = '12345678';
    let uid = '' + user_id; //stringA
    let key = 'read.bluebirdabc.com-web-api';
    let i = 0;
    while (uid.length < 8) {
        uid += num[i];
        i++;
    }

    let randomStr = generateRandomString(12);
    let timestamp = '' + parseInt(Date.now() / 1000);

    let toSign = uid + token + uid + key + randomStr + timestamp;
    let sign = sha1(toSign);

    return {
        ...queries,
        token: token,
        timestamp: timestamp, //当前毫秒值
        rand: randomStr, //随机字符串
        sign: sign,      //签名串
    };
}

function checkIfNeedRelogin(code) {
    return [
        1001, //userId为空
        1002, //token为空
        1003, //签名为空
        1004, //userId不存在
        1005, //token已失效
        1006, //签名错误
    ].includes(code);
}

function invokePostWebApi(url, data, config, toLogin, cbSuccess, cbError) {
    return axios.post(url, data, config).then(function (res){
        if(checkIfNeedRelogin(res.data.code)) {
            console.log(res.data.msg);
            toLogin();
            return null;
        }
        if(cbSuccess) cbSuccess(res);
    }).catch((error) => {
        console.log("error", error, url);
        if(cbError) cbError(error);
    });
}

export function invokeLessonPlayerWebApi(queries, apiName, param, toLogin, cbSuccess, cbError) {
    let auth = makeWebApiAuthObject(queries);
    if(!auth) {
        toLogin();
        return null;
    }

    let url = LESSON_PLAYER_API_BASE_URL+apiName;
    return invokePostWebApi(url, {
        ...auth,
        ...param
    }, {}, toLogin, cbSuccess, cbError);
}

export function invokeLessonPlayerWebFormApi(queries, apiName, formData, toLogin, cbSuccess, cbError) {
    let auth = makeWebApiAuthObject(queries);
    if(!auth) {
        toLogin();
        return null;
    }

    formData.append('auth', JSON.stringify(auth));
    let config = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    }

    let url = LESSON_PLAYER_API_BASE_URL+apiName;
    return invokePostWebApi(url, formData, config, toLogin, cbSuccess, cbError);
}

// 创建问答对话接口
export function createQaDialogue(queries, param, toLogin, cbSuccess, cbError) {
    return invokeLessonPlayerWebApi(queries, 'create-qa-dialogue', param, toLogin, cbSuccess, cbError);
}

export function invokeLessonPlayerStreamWebApi(queries, apiName, param, toLogin, onOneObject, onFinish) {
    let url = LESSON_PLAYER_API_BASE_URL+apiName;
    let auth = makeWebApiAuthObject(queries);
    let postData = {
        ...auth,
        ...param
    };
    let running = true;
    return invokeStreamWebApi(url, postData, ()=>{return running;}, (one) => {
        let oneObj = JSON.parse(one);
        if(checkIfNeedRelogin(oneObj.code)) {
            running = false;
            toLogin();
        } else {
            onOneObject(oneObj);
        }
    }, onFinish);
}

export function invokeStreamWebApi(url, postData, runningFlag, onOneResult, onFinish) {
    let controller = new AbortController()
    const loadData = async () => {
        try {
            const response = await fetch(url, {
                method: 'post',
                headers: {
                    'Accept': 'text/event-stream;charset=UTF-8',
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(postData),
                signal: controller.signal
            })

            let content = '';
            const reader = (response).body.getReader()
            while (runningFlag()) {
                const {done, value} = await reader.read()

                if(value) {
                    let str = new TextDecoder().decode(value);
                    content += str;
                }

                while(runningFlag() && content.length > 0) {
                    let idx = content.indexOf("\n\n");
                    if(idx < 0)
                        break;

                    let one = content.substring(0, idx);
                    console.log('STREAM-A', one);
                    onOneResult(one);

                    content = content.substring(idx+2);
                }

                if (done) {
                    console.log("STREAM DONE1");
                    break
                }
            }
            if(runningFlag() && content.length > 0) {
                console.log('STREAM-B', content);
                onOneResult(content);
            }
            onFinish();
        } catch (e) {
            console.log('请求失败', e);
            onFinish(e);
        }
    }

    return loadData();
}
